import { render, staticRenderFns } from "./ClaimStep.vue?vue&type=template&id=69363927&"
import script from "./ClaimStep.vue?vue&type=script&lang=js&"
export * from "./ClaimStep.vue?vue&type=script&lang=js&"
import style0 from "./ClaimStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports